import type {
	CommoditiesCreateFormInput,
	CommoditiesEditFormInput,
} from "web_myplann/Portfolio/Forms/CommoditiesForm/commoditiesFormSchema";

export const COMMODITIES_EDIT_FORM_DEFAULT_VALUES: CommoditiesEditFormInput = {
	name: "",
	contractNumber: "",
	producer: "",
	product: "",
	signedAt: null,
	startAt: null,
	endAt: null,
	tools: [],
};

export const COMMODITIES_CREATE_FORM_DEFAULT_VALUES: CommoditiesCreateFormInput =
	{
		...COMMODITIES_EDIT_FORM_DEFAULT_VALUES,
		value: null,
		invested: null,
		valueDate: null,
	};

export const getCommoditiesCreateFormDefaultValues =
	(): CommoditiesCreateFormInput => ({
		...COMMODITIES_CREATE_FORM_DEFAULT_VALUES,
		valueDate: new Date(),
	});
